export default __webpack_public_path__ + "static/media/attachment-attach.7382e164.png";